import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, P, Stack, Text, useText } from "@sveabank/cc-common";
import Paper from "../../../../components/paper";
import type { ClcBeneficialOwner } from "../../../../types/clc-application";

type Props = {
	open: boolean;
	setOpen: (isOpen: boolean) => void;
	person: ClcBeneficialOwner;
	deleteBeneficialOwner: (nationalId: string) => void;
};

export const DeleteBeneficialOwnerModal = ({
	open,
	setOpen,
	person,
	deleteBeneficialOwner,
}: Props) => {
	const [t, texts] = useText();

	return (
		<Dialog
			isOpen={open}
			setOpen={setOpen}
			icon="error"
			center
			size="small"
			heading={t(texts.newCompany.beneficialOwnership.deleteBeneficialOwnerModalHeading)}
		>
			<Dialog.Content>
				<Stack gap={4}>
					<Stack gap={2}>
						<Text align="start">
							{t(texts.newCompany.beneficialOwnership.deleteBeneficialOwnerModalText)}
						</Text>
					</Stack>

					<Paper className="bg-background-tertiary">
						<Text align="left">
							<Text component="p" bold>
								{person.firstName} {person.lastName}
							</Text>
							<P>{person.postalAddress}</P>
							<P>
								{person.postCode} {person.town}
							</P>
						</Text>
					</Paper>
				</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button
						onPress={() => {
							deleteBeneficialOwner(person.nationalId);
							setOpen(false);
						}}
					>
						{t(texts.common.remove)}
					</Button>
					<Button variant="secondary" onPress={() => setOpen(false)}>
						{t(texts.common.abort)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
